import { useRef, useEffect, useState, useContext } from 'react';
import { deleteObject, ref, } from 'firebase/storage';
import { auth, db, storage } from '../../firebase';
import { addDoc, setDoc, collection, getDocs, getDoc, doc, getCountFromServer, arrayUnion } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { authenticatedFetch } from '../../services/apiClient';
import styles from './index.module.css';
import { ThemeContext } from "../../context/ThemeContext";
import lightLogo from '../home/logolong.png';
import darkLogo from '../home/OLDlogolong.png';


export default function Form3(props) {
  const navigate = useNavigate();
  const priceInput = useRef();
  const [logo, setLogo] = useState(lightLogo);
  const [permCount, setPermCount] = useState(0);
  const [isPermCounted, setIsPermCounted] = useState(false);
  const [questionFeatures, setQuestionFeatures] = useState(null);
  const [form2Data, setForm2Data] = useState(null);
  const [nubPar, setnubPar] = useState(0);
  const maxDecisions = useRef();
  const studyName = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitText, setSubmitText] = useState("Submit");
  const { isDarkMode } = useContext(ThemeContext);
  const [theme, setTheme] = useState(isDarkMode);
  const [totalFeatureCount, setTotalFeatureCount] = useState(0);
  const [pricePerParticipant, setPricePerParticipant] = useState(0.1); // Default fallback
  const [showCompensationTooltip, setShowCompensationTooltip] = useState(false);
    const [showCompensationTooltip1, setShowCompensationTooltip1] = useState(false);
  let BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  // Fetch pricing configuration from Firebase on mount
  useEffect(() => {
    const fetchPricingConfig = async () => {
      try {
        const configDocRef = doc(db, 'companyConfig', 'dashboardLimits');
        const configDoc = await getDoc(configDocRef);
        if (configDoc.exists()) {
          const data = configDoc.data();
          if (typeof data.pricePerParticipant === 'number' && data.pricePerParticipant >= 0) {
            setPricePerParticipant(data.pricePerParticipant);
          } else {
            console.warn('Invalid pricePerParticipant in Firebase, using default 0.1');
          }
        } else {
          console.warn('companyConfig/dashboardLimits not found in Firebase, using default 0.1');
        }
      } catch (error) {
        console.error('Error fetching pricing config:', error);
      }
    };
    fetchPricingConfig();
  }, []);

  // Cycle submit button text while submitting
  useEffect(() => {
    let interval;
    if (isSubmitting) {
      let dots = 0;
      setSubmitText("Submitting");
      interval = setInterval(() => {
        dots = (dots + 1) % 4;
        setSubmitText("Submitting" + ".".repeat(dots));
      }, 400);
    } else {
      setSubmitText("Submit");
    }
    return () => clearInterval(interval);
  }, [isSubmitting]);

  useEffect(() => {
    setTheme(isDarkMode); 
    setLogo(isDarkMode ? darkLogo : lightLogo);
  }, [isDarkMode]);

  const handleChange = (e) => {
        const value = e.target.value; // keep as string for input
        const newPrice = (pricePerParticipant * parseFloat(value || 0)).toFixed(2); // calculate price using Firebase config
        setnubPar(newPrice);
   };

  let userFeatures = [];

  if (Array.isArray(form2Data) && form2Data.length > 0) {
    // Create a map to count occurrences of each categoryName
    const categoryCounts = {};

    // First, populate userFeatures and count occurrences of each categoryName
    form2Data.forEach((data) => {
      data.features.forEach((feature) => {
        const categoryName = data.name;
        if (!categoryCounts[categoryName]) {
          categoryCounts[categoryName] = 0;
        }
        categoryCounts[categoryName]++;
        userFeatures.push({
          categoryName: categoryName,
          featuresName: feature.name,
        });
      });
    });

    // Now, update userFeatures with the balanceScore
    userFeatures = userFeatures.map((feature) => {
      const count = categoryCounts[feature.categoryName];
      const balanceScore = count > 0 ? (1 / count).toFixed(2) : 0; // Reciprocal of the count
      return {
        ...feature,
        balanceScore: balanceScore,
      };
    });
  }
  useEffect(() => {
    const storedQuestionFeatures = JSON.parse(localStorage.getItem("questionFeatures"));
    const storedForm2Data = JSON.parse(localStorage.getItem("formData2"));
    if (storedQuestionFeatures) {
      setQuestionFeatures(storedQuestionFeatures);
    } else {
      console.error("Form1 Data is missing or invalid.");
    }

    if (storedForm2Data) {
      setForm2Data(storedForm2Data);
    }
    if (storedForm2Data) {
      getPermCount(props.userId);
    }
  }, [props.userId]);
  
 //count how many product features there are
  function countForm1Features(questionFeatures) {
    if (!questionFeatures || !Array.isArray(questionFeatures)) return 0;

    const featureSets = {
        title: new Set(),
        price: new Set(),
        description: new Set(),
        image: new Set(),
    };

    questionFeatures.forEach((item) => {
      if (!item) return; // tolerate incomplete saved entries
      const categoryLower = item?.categoryName?.toLowerCase();
      const featuresName = item?.featuresName;
        
        // Check if value exists and is not an empty string
        if (categoryLower && featuresName && featuresName !== " ") {
            if (featureSets[categoryLower]) {
                featureSets[categoryLower].add(featuresName);
            }
        }
    });

    const totalFeatures = Object.values(featureSets)
        .map(set => {
            console.log(`Set size: ${set.size}`);
            return set.size;
        })
        .reduce((sum, size) => {
            console.log(`Current sum: ${sum}, adding size: ${size}`);
            return sum + size;
        }, 0);

    console.log('Total features calculated:', totalFeatures);
    return totalFeatures;
  }

  // Usage in useEffect:
  useEffect(() => {
    const storedQuestionFeatures = JSON.parse(localStorage.getItem("questionFeatures"));
    const storedForm2Data = JSON.parse(localStorage.getItem("form2Data"));
    
    let calculatedFeatureCount = 0;

    // Handle Form1 data
    if (storedQuestionFeatures) {
        setQuestionFeatures(storedQuestionFeatures);
        calculatedFeatureCount += countForm1Features(storedQuestionFeatures);
        console.log("Form 1 features:", calculatedFeatureCount);
    }

    // Add Form2 data length if it exists and is an array
    if (Array.isArray(storedForm2Data) && storedForm2Data.length > 0) {
        calculatedFeatureCount += storedForm2Data.length;
        console.log("Added Form 2 features:", storedForm2Data.length);
    }

    console.log("Total features (Form1 + Form2):", calculatedFeatureCount);
    setTotalFeatureCount(calculatedFeatureCount); // Store in state
  }, [props.userId]);

  async function getPermCount() {
    try {
      const docRef = collection(db, "products", `${props.userId}`, "permutations");
      const docSnap = await getCountFromServer(docRef);
      setPermCount(docSnap.data().count);
      setIsPermCounted(true);
    } catch (error) {
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for duplicates in questionFeatures
    if (questionFeatures && Array.isArray(questionFeatures)) {
        const featureKeys = new Set();
        const duplicates = [];
        
        questionFeatures.forEach((feature) => {
            const key = `${feature.categoryName}::${feature.featuresName}`;
            if (featureKeys.has(key)) {
                duplicates.push(`${feature.categoryName}: ${feature.featuresName}`);
            }
            featureKeys.add(key);
        });

        if (duplicates.length > 0) {
            alert(`Duplicate features not allowed:\n${duplicates.join("\n")}`);
            setIsSubmitting(false);
            return;
        }
    }

    if (totalFeatureCount > 40) {
        alert("Cannot submit: Too many features (maximum 40 allowed)");
        return;
    }

    setIsSubmitting(true);

    try {
      const studyNameValue = (studyName.current.value || "").trim();

      if (!studyNameValue) {
        alert("Study name is required.");
        setIsSubmitting(false);
        return;
      }

      if (!validateStudyName(studyNameValue)) {
        setIsSubmitting(false);
        return;
      }

      const form3Data = {
        price: priceInput.current.value,
        studyName: studyNameValue,
        maxDecisions: maxDecisions.current.value,
      };

        const user = auth.currentUser;
        if (!user) {
          navigate('/login');
          return;
        }

        // ----------------------------
        // CREATE PAYLOAD FOR BACKEND
        // questionFeatures is already in the standardized format: [{ categoryName, featuresName }, ...]
        // Question is stored separately in localStorage
        // ----------------------------
        
        const storedQuestion = JSON.parse(localStorage.getItem("form1Question")) || "";
        
        const payload = {
            Userid : user.uid,
            price: form3Data.price,
            maxDecisions: form3Data.maxDecisions,
          studyName: form3Data.studyName,
            question: storedQuestion,
            userFeatures: userFeatures,
            questionFeatures: questionFeatures,  // Already in standardized format
            priceCurrency: localStorage.getItem("priceCurrency") || "USD",
        };
        
        const res = await authenticatedFetch(`${BACKEND_URL}/api/project/create`, {
            method: "POST",
            body: JSON.stringify(payload),
        });

        const result = await res.json();

        if (!result.success) {
            throw new Error(result.message || "Failed to create project");
        }

        // Redirect to Stripe checkout URL returned by backend
        if (result.data && result.data.checkoutUrl) {
            window.location.href = result.data.checkoutUrl;
        } else {
            throw new Error("Checkout URL missing");
        }

    } catch (error) {
        console.error("Submission failed:", error);
        alert("Submission failed: " + error.message);
    } finally {
        setIsSubmitting(false);
    }
};


  function handlePrevious2() {

    navigate('/form2');
  }
  function handleCancel() {
    const storedData = JSON.parse(localStorage.getItem('form1Categories'));
    console.log("storedData", storedData);
  
    if (storedData && storedData.length > 0) {
      storedData.forEach((category) => {
        if (category.features && category.features.length > 0) {
          category.features.forEach((feature) => {
            // Check if this feature is an image
            if (category.name === "Image" && feature.name) {
              const imageURL = feature.name;
  
              // Check if imageURL is defined and not just a space
              if (imageURL && imageURL.trim() !== '') {
                try {
                  const imageRef = ref(storage, imageURL);
  
                  // Delete the image from Firebase Storage
                  deleteObject(imageRef)
                    .then(() => {
                      console.log("Image deleted successfully:", imageURL);
                    })
                    .catch((error) => {
                      console.error("Error occurred while deleting image:", error);
                    });
                } catch (error) {
                  console.error("Error handling image URL:", error);
                }
              } else {
                console.log('No valid image URL found for item, skipping deletion.');
              }
            }
          });
        }
      });
    }
  
    localStorage.removeItem("form1Categories");
    localStorage.removeItem("form1Question");
    localStorage.removeItem("questionFeatures");
    localStorage.removeItem("formData2");
    localStorage.removeItem("priceCurrency");
    navigate("/");
  }

  function validateStudyName(name) {
    // Regular expression to match invalid characters in a filename
    const invalidChars = /[<>:"/\\|?*%]/;
  
    // Check if the study name contains any invalid characters
    if (invalidChars.test(name)) {
      
      alert("Study name contains invalid characters. Please avoid: < > : \" / \\ | ? * %");
      return false;
    }
    return true;
  }



// ... (keep your useEffect and handleSubmit as they were)

  return (
    <>
    <header>
        <span></span>
        <img
            src={logo}  
            alt="Linesol"
            style={{ height: '44px' }}
          />
        <span></span>
      </header>
    <div className={styles.container}>
      
      
      <form 
        onSubmit={handleSubmit} 
        className={styles.form} 
        style={{
          boxShadow: theme
            ? 'rgba(52, 51, 51, 0.44) 0px 0px 0px 2px'
            : 'rgba(201, 201, 201, 0.23) 0px 0px 0px 2px',
        }}
      >
        <div className={styles.headerTop}>
          <p>Question Features</p>
          <p>User Features</p>
          <p style={{ color: "#007bff" }}>Study Metadata</p>
        </div>
        {/* Warning message div */}
        {totalFeatureCount > 40 && (
                <div 
                  style={{
                    
                    color: '#c62828',
                    padding: '10px',
                    borderRadius: '5px',
                    textAlign: 'center'
                  }}
                >
                  Features exceed maximum of 40 (product features + user features). Current total: {totalFeatureCount}
                </div>
              )}
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <h3 className={styles.title}>Study Name:</h3>
          <div className={styles.row}>
            <input 
              style={{borderColor: '#007bff', color: theme ? "white" : "black" , background: theme ? "#141414" : "white" }} 
              type="text" 
              ref={studyName} 
              required 
              placeholder="Study Name" 
            />
          </div>
          <h3>Number of Participants:</h3>
          {/* <p style={{ textAlign: 'justify'}}>
            We recommend a minimum of 200 participants, with the number of participants at least 20 times the number of features evaluated (question card + user features). For enhanced insights: Larger samples (e.g., 500+ participants) often yield more robust findings, better predictive accuracy, and greater confidence in your conclusions.
          </p> */}
          <p style={{ textAlign: 'justify'}}>
            Ensure that your sample size reflects the diversity of your target audience, helping foster accurate insights into user preferences and behaviors, leading to better-informed decisions.
          </p>
          <div className={styles.row}>
            <input 
              style={{borderColor: '#007bff', color: theme ? "white" : "black" , background: theme ? "#141414" : "white" }} 
              type="number" 
              onChange={e=> handleChange(e)} 
              ref={maxDecisions} 
              required 
              placeholder="Number of Participants" 
            />
          </div>
          <h3 className={styles.title}>Price:</h3>
          <p style={{ textAlign: 'justify' }}>
            Participants must spend at least 10 seconds considering your question, receive financial compensation (at up to{" "}
            <span
              style={{
                textDecoration: "underline dotted",
                cursor: "pointer",
                position: "relative",
                display: "inline-block",
              }}
              onMouseEnter={() => setShowCompensationTooltip(true)}
              onMouseLeave={() => setShowCompensationTooltip(false)}
              onClick={() => setShowCompensationTooltip((prev) => !prev)}
            >
              $18/hr
              {showCompensationTooltip && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    marginBottom: "8px",
                    padding: "6px 10px",
                    background: "#333",
                    color: "#fff",
                    fontSize: "12px",
                    borderRadius: "4px",
                    whiteSpace: "nowrap",
                    zIndex: 100,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  $0.05 per 10 second Yes/No response
                  {/* tooltip arrow */}
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      border: "6px solid transparent",
                      borderTopColor: "#333",
                    }}
                  />
                </div>
              )}
            </span>
            ) and have strong {" "}
            <span
              style={{
                textDecoration: "underline dotted",
                cursor: "pointer",
                position: "relative",
                display: "inline-block",
              }}
              onMouseEnter={() => setShowCompensationTooltip1(true)}
              onMouseLeave={() => setShowCompensationTooltip1(false)}
              onClick={() => setShowCompensationTooltip1((prev) => !prev)}
            >
              privacy protections
              {showCompensationTooltip1 && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    marginBottom: "8px",
                    padding: "6px 10px",
                    background: "#333",
                    color: "#fff",
                    fontSize: "12px",
                    borderRadius: "4px",
                    whiteSpace: "nowrap",
                    zIndex: 100,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  No email in signup or payout
                  {/* tooltip arrow */}
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      border: "6px solid transparent",
                      borderTopColor: "#333",
                    }}
                  />
                </div>
              )}
            </span> {" "}to foster authentic responses. An automated data analysis pipeline helps identify winning combinations of product designs, audiences and prices. The results include the raw data (csv), a summary of the results (csv) and a professional report (pdf).
          </p>
          <div style={{ position: "relative", width: "100%" }}>
            <span
              aria-hidden="true"
              style={{
                position: "absolute",
                left: "12px",
                top: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                transform: "translateY(-9px) scaleY(0.8)",
                transformOrigin: "bottom",
                color: theme ? "white" : "black",
                pointerEvents: "none",
              }}
            >
              $
            </span>
            <input
              style={{ borderColor: '#007bff', color: theme ? "white" : "black", background: theme ? "#141414" : "white", paddingLeft: "24px" }}
              id="price"
              type="number"
              ref={priceInput}
              value={nubPar}
              className={styles.input}
              placeholder="Enter price"
              readOnly
            />
          </div>

          <div style={{ display: "flex", columnGap: "10px", marginTop: "20px" }}>
            <button onClick={handlePrevious2} style={{ padding: "10px 20px", }}>Previous</button>
            <button 
              type="button" 
              className={styles.cancelBtn}  
              style={{padding: "5px 20px", border: "none", borderRadius: "5px", }}  
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className={styles.submitBtn}  
              style={{padding: "5px 20px", border: "none", borderRadius: "5px", }} 
              disabled={isSubmitting}
            >
              {submitText}
            </button>
          </div>
        </div>
      </form>
    </div>
    </>
  );
}
